import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { ISwitchModePopupComponentData } from './interfaces';

import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { AzavistaButtonModule } from '@azavista/components/button';
import { SwitchMode } from '../../shared/enums';
import { TRANSLATION_MAP } from '../../shared/const';

@Component({
    templateUrl: 'switch-mode-popup.component.html',
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        AzavistaButtonModule,
        TranslateModule
    ]
})
export class SwitchModePopupComponent {
    constructor(
        public dialogRef: MatDialogRef<SwitchModePopupComponent, boolean>,
        @Inject(MAT_DIALOG_DATA) public data: ISwitchModePopupComponentData
    ) {
    }

    onCancelClick(): void {
        this.dialogRef.close(false);
    }

    onSwitchMode(): void {
        this.dialogRef.close(true);
    }

    get modeName(): string {
        return this.data.mode === SwitchMode.checkInMode ? TRANSLATION_MAP.CHECK_IN : TRANSLATION_MAP.BADGE_PRINT;
    }
}
